<ng-container *ngIf="loaded">
    <app-top-tabs></app-top-tabs>

    <section class="result-summary my-2">
        <div class="row">
            <div class="col-12 col-lg-6">
                <app-status [total]="result.total"></app-status>
            </div>
            <div class="col-12 col-lg-6 ps-lg-5">
                <app-details [result]="result"></app-details>
            </div>
        </div>

        @if (combinedLayout) {
        <hr>
        <app-recommendation-tile [result]="result" [inline]="true"></app-recommendation-tile>
        }
    </section>

    <app-history [result]="result"></app-history>

    @if (!combinedLayout) {
    <app-recommendation-tile [result]="result"></app-recommendation-tile>
    }

    <app-more-tips [result]="result"></app-more-tips>

    <app-redo-test></app-redo-test>

</ng-container>
